export function init() {
  console.log("nav init");

  //  console.log("init nav menu");
  jQuery("header .search").on("click", ".action", function (e) {
    jQuery("header .search").toggleClass("active");
  });

  jQuery(".headerpopup").on("click", function (e) {
    e.stopPropagation();
  });

  jQuery("header").on("click", ".haspopup", function (e) {
    //  console.log("haspopup clicked: ")
    if (!jQuery(".hamburger:hidden").length) {
      e.stopPropagation();
      //   console.log("click toggle active")
      jQuery(this).toggleClass("active");
    }
  });

  jQuery("header").on("mouseover", ".haspopup", function (e) {
    // console.log("header haspopup mouseover: ", jQuery(this).find("input[name='username']").length);
    if (jQuery(".hamburger:hidden").length) {
      jQuery(".haspopup").removeClass("active");
      jQuery(this).addClass("active");
    }
  });

  jQuery("header").on("mouseout", ".headerpopup", function () {
    // console.log("header popup mouseout input username? ", jQuery(this).find("input[name='username']").length);
    if (
      jQuery(this).find("input[name='username']").length &&
      jQuery(this).find("input[name='username']").is(":focus")
    ) {
      // this is the login form, don't toggle active
      return;
    }
    jQuery(this).parents(".active").removeClass("active");
  });

  jQuery("#nav .wp-block-group")
    .has("> .wp-block-group__inner-container")
    .on("mouseover", function () {
      jQuery("#nav > .wp-block-group").removeClass("active");
      jQuery(this).siblings(".wp-block-group").removeClass("active");
      jQuery(this)
        .siblings(".wp-block-group")
        .find(".active")
        .removeClass("active");

      //jQuery("#nav > .wp-block-group .wp-block-group").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(this)
        .find(".wp-block-group__inner-container > .wp-block-group")
        .addClass("active");
    });

  jQuery(".wp-block-group__inner-container > .wp-block-group").on(
    "mouseout",
    function () {
      jQuery(this).parents(".wp-block-group.active").removeClass("active");
    },
  );

  jQuery(".grid-list li").remove();
  jQuery("<li class='filterstoggle'></li>").appendTo(".grid-list");
  jQuery(".grid-list").on("click", ".filterstoggle", function () {
    jQuery(".filters").toggleClass("open");
    jQuery(".filterstoggle").toggleClass("open");
  });

  jQuery(".hamburger").on("click", function (e) {
    jQuery("#body").toggleClass("navopen");
  });

  jQuery(function ($) {
    $(
      "#nav > .wp-block-group, #nav > .wp-block-group.menu2 > .wp-block-group",
    ).on("click", function (e) {
      if (!$("#body").hasClass("navopen")) return;

      const $target = $(e.target);

      if (
        $target.is("input, textarea, select, button") ||
        $target.closest("input, textarea, select, button").length
      ) {
        return;
      }

      if ($target.closest(".menu").length) {
        return; // allow normal <a> click
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      const $this = $(this);

      const isOpen = $this.hasClass("open");

      if ($this.hasClass("searchform")) {
        return;
      }
      // if ($this.hasClass("search") && $this.hasClass("active")) {
      //   return;
      // }

      $(
        "#nav > .wp-block-group, #nav > .wp-block-group.menu2 > .wp-block-group",
      ).removeClass("open");

      // 3️⃣ Only reopen if it wasn’t already open
      if (!isOpen) {
        $this.addClass("open");
      }
    });
  });

  //jQuery(".search-action").clone().appendTo(jQuery("#main-navigation"));
}
